export default "https://studio-ui-deployments.apollographql.com/build/static/assets/favicon-staging.cc2f8d36f7d3fc6c63960cd3c79081e8.png";